@if (notify.notifications$ | async; as notifications) {
  <div
    [ngClass]="{'ring': notifications.length && !notify?.isNotUnique}"
    (click)="notify.toggle()" class="notify-badge">
    <i [ngClass]="{active: notify.sideNavOpen}" class="icon-notify"></i>
    @if (notifications.length) {
      <span class="notify-badge__count" [ngClass]="{'opened':notify?.isNotUnique || notify?.isOpened}">{{notifications?.length}}</span>
    }
  </div>
  <aside
    ClickOutside
    (clickOutside)="notify.close()"
    [options]="{ignoreOutsideComponents: ['.notify-item', '.notify-badge']}"
    [ngClass]="{'open': notify.sideNavOpen}"
    class="notify-menu mobile">
    <app-notification-center [lists]="notifications"></app-notification-center>
  </aside>
}
